import type { GameDetailsDto, GameDto } from '@/queries/games/games.schema';
import { GameDetailsDtoSchema } from '@/queries/games/games.schema';
import { isEmpty } from '@/utils/objects.utils';

export const detailsNameMap: { [key: string]: string } = {
  volatility: 'Volatility',
  rtp: 'RTP',
  rtpRange: 'RTP range',
  minBet: 'Min bet',
  minBetRange: 'Min bet range',
  maxBet: 'Max bet',
  maxBetRange: 'Max bet range',
  themes: 'Themes',
  features: 'Features',
  category: 'Category',
  subCategory: 'Sub category',
  rtpType: 'RTP type',
  topPrize: 'Top prize',
  topPrizeRange: 'Top prize range',
  subFeature: 'Sub feature',
  gameMechanics: 'Game mechanics',
  subGameMechanics: 'Sub game mechanics',
  subSubGameMechanics: 'Detailed mechanics',
  grid: 'Grid',
  subThemes: 'Sub themes',
  promoTools: 'Promo tools',
  jackpotType: 'Jackpot type',
  subJackpotType: 'Sub jackpot type',
};

// Raw numeric fields with no dedicated label/UX yet - not shown as their own row.
export const hiddenDetailKeys = new Set<keyof GameDetailsDto>([
  'maxBetNumber',
  'maxMultiplier',
  'maxWin',
]);

export const hasDetailsValue = (value: unknown) => Array.isArray(value) ? value.length > 0 : Boolean(value);

export const hasVisibleGameDetails = (details?: GameDetailsDto | null) => {
  if (!details) {
    return false;
  }

  const parseResult = GameDetailsDtoSchema.safeParse(details);

  if (!parseResult.success) {
    return false;
  }

  return Object.entries(parseResult.data)
    .filter(([key]) => !hiddenDetailKeys.has(key as keyof GameDetailsDto))
    .some(([, value]) => hasDetailsValue(value));
};

export const GameTabsMap = {
  gallery: {
    id: 'game-gallery',
    title: 'game-details.gallery',
  },
  details: {
    id: 'game-details',
    title: 'game-details.game-details',
  },
  about: {
    id: 'game-about',
    title: 'game-details.about-game',
  },
  compare: {
    id: 'game-compare',
    title: 'game-details.compare',
  },
  rating: {
    id: 'game-rating',
    title: 'game-details.rating',
  },
} as const;

export const getAvailableGameTabs = (game: GameDto | null | undefined) => {
  const t: { id: string; title: string }[] = [];

  if (!game) {
    return [];
  }

  if (!isEmpty(game.assets)) {
    t.push(GameTabsMap.gallery);
  }

  if (hasVisibleGameDetails(game?.details)) {
    t.push(GameTabsMap.details);
  }

  const emptyAbout = isEmpty(game?.pageContent?.body) || (game?.pageContent?.body && game.pageContent.body.length <= 2);

  if (!emptyAbout) {
    t.push(GameTabsMap.about);
  }

  // TODO: add rest of tabs later - compare
  return t;
};
